import { EditIcon } from "graphics/icons/InfoPage/EditIcon";
import React from "react";
import { useDispatch } from "react-redux";
import { editEfficeContent } from "slices/efficeTreeSlice";

const Editor = ({
  effId,
  originalContent,
  loading,
  setLoading,
  content,
  setContent,
  editting,
  setEditting,
}) => {
  const dispatch = useDispatch();

  if (editting) {
    return (
      <div className="editting-textarea">
        {loading ? (
          <span>uploading changes...</span>
        ) : (
          <>
            <button
              className="text-danger cursor-pointer PS-account-edit-name"
              onClick={() => {
                setEditting(false);
              }}
            >
              Cancel
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button
              className="text-primary cursor-pointer PS-account-edit-name"
              onClick={() => {
                let trimmedValue = content.trim();
                if (!loading && trimmedValue.length !== 0) {
                  setLoading(true);
                  dispatch(editEfficeContent(effId, trimmedValue))
                    .then(() => {
                      setEditting(false);
                      setLoading(false);
                    })
                    .catch(() => {
                      setEditting(false);
                      setLoading(false);
                    });
                }
              }}
            >
              CONFIRM
            </button>
          </>
        )}
      </div>
    );
  } else {
    return (
      <button
        className="action-light-side-text edit-text"
        onClick={() => {
          setContent(originalContent);
          setEditting(true);
        }}
      >
        <EditIcon />
        <em>edit</em>
      </button>
    );
  }
};

export default Editor;
